module.exports = __webpack_public_path__ + "img/charging.669b1a76.gif";